import api from './api';

export const reservationService = {
  async getReservations(params = {}) {
    const response = await api.get('/reservations', { params });
    return response.data;
  },
  
  async getReservationById(id) {
    const response = await api.get(`/reservations/${id}`);
    return response.data;
  },
  
  async createReservation(reservationData) {
    const response = await api.post('/reservations', reservationData);
    return response.data;
  },
  
  async updateReservation(id, reservationData) {
    const response = await api.put(`/reservations/${id}`, reservationData);
    return response.data;
  },
  
  async updateReservationStatus(id, statusData) {
    const response = await api.patch(`/reservations/${id}/status`, statusData);
    return response.data;
  },
  
  async cancelReservation(id, reason) {
    const response = await api.delete(`/reservations/${id}`, { data: { reason } });
    return response.data;
  },
  
  async generateVoucher(id) {
    const response = await api.get(`/reservations/${id}/voucher`);
    return response.data;
  }
};
